import SVGIcon from "ui/icons/SVGIcon";
import type { IconStatusProps } from "./iconStatusTypes";

export default function IconInfo({ fill = "#336CB8", outline = false, ...props }: IconStatusProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <circle cx="8" cy="8" r="6" fill={outline ? "none" : fill} stroke={outline ? fill : "none"} />
      <path
        d="M8.68277 11H7.31477V6.527H8.68277V11ZM7.19777 5.159C7.19777 4.718 7.55777 4.358 7.98977 4.358C8.43977 4.358 8.79977 4.718 8.79977 5.159C8.79977 5.6 8.43977 5.96 7.98977 5.96C7.55777 5.96 7.19777 5.6 7.19777 5.159Z"
        fill={outline ? fill : "white"}
      />
    </SVGIcon>
  );
}
